import React from 'react';
import PropTypes from 'prop-types';

const Message = ({ ariaLive = 'polite', message }) => (
  <div
    role="region"
    aria-live={ariaLive}
  >
    {message}
  </div>
);

Message.propTypes = {
  ariaLive: PropTypes.oneOf(['polite', 'assertive']),
  message: PropTypes.string,
};

Message.defaultProps = {
  message: '',
  ariaLive: 'polite',
};

export default Message;
